// Loader.js
import React from "react";
import { ThreeDots } from "react-loader-spinner";
import Colors from "../../theme/Colors";
import "./style.css";

const Loader = ({ loading }) => {
  return (
    <div className={`loader-container ${loading ? "show" : "hide"}`}>
      <ThreeDots
        visible={true}
        height="50"
        width="50"
        color={Colors.primaryColor}
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default Loader;
